import { apiFetch } from './api.js';

export type InvitePreviewStatus = 'Pending' | 'Expired' | 'Revoked' | 'Accepted';
export type InviteRouteState = 'sign-in' | 'accept' | 'wrong-email' | 'unavailable';

export interface InvitePreview {
  email: string;
  role: 'admin' | 'member';
  status: InvitePreviewStatus;
  expiresAt: string;
  workspace: { name: string; slug: string };
}

export function getInviteRouteState(
  invite: InvitePreview,
  signedInEmail: string | null,
): InviteRouteState {
  if (invite.status !== 'Pending') return 'unavailable';
  if (!signedInEmail) return 'sign-in';
  return invite.email.toLowerCase() === signedInEmail.toLowerCase() ? 'accept' : 'wrong-email';
}

export async function getInvitePreview(token: string): Promise<InvitePreview> {
  return apiFetch<InvitePreview>(`/invitations/${encodeURIComponent(token)}`);
}

export async function acceptInvite(token: string): Promise<{ destination: string }> {
  return apiFetch<{ destination: string }>(`/invitations/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
  });
}
